<template>
  <div class="task-status-reject">
    <InputComponent v-model="data.message" required autofocus type="textarea" :label="$t('reason')">
      <template #below>
        <Alert class="mt-1">{{ $t('reasonWillBeSentToApplicants') }}</Alert>
      </template>
    </InputComponent>
    <div class="task-status-reject__actions">
      <ButtonComponent
        class="task-status-reject__actions-cancel"
        :label="$t('cancel')"
        :icon="['fal', 'times']"
        @click="$emit('cancel')"
      />

      <ButtonComponent
        :label="$t('decline')"
        type="submit"
        :promise="promise"
        theme="error"
        :icon="['fal', 'arrow-to-right']"
        :disabled="!data.message"
        :success-label="$t('sent')"
        @click="$emit('input', 'rejected', data.message)"
      />
    </div>
  </div>
</template>

<script>
import { mapi18n } from '@/i18n'
import Validator from '@/mixins/validator'

import { InputComponent } from 'vue-elder-input'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  mixins: [Validator],
  props: {
    promise: Promise,
  },

  data() {
    return {
      data: {
        message: null,
      },
      validator: {
        rules: {
          message: 'required',
        },
        labels: 'labels',
        data: 'data',
      },
    }
  },
  computed: {
    ...mapi18n('labels', {
      message: ['reason'],
    }),
  },
  components: {
    InputComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.task-status-reject {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
}
</style>
